/* eslint-disable import/no-cycle */
/* eslint-disable no-use-before-define */
/* eslint-disable import/order */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import {
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
  TypedUseSelectorHook,
  Provider,
} from 'react-redux';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { configureStore } from '@reduxjs/toolkit';
import userData from './service/UserData';
import listingsData from './service/ListingData';

type AppDispatch = typeof store.dispatch;
type RootState = ReturnType<typeof store.getState>;
export const useDispatch = () => useReduxDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

const store = configureStore({
  reducer: {
    userData: userData.reducer,
    listingData: listingsData.reducer,
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
